module.exports = __webpack_public_path__ + "img/imgs.d52a34da.jpg";